var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockedUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.442,
    height: 121.903,
    viewBox: "0 0 86.442 121.903",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "blockedUsers",
    transform: "translate(188.018 78.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13850",
    "data-name": "Group 13850"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M-171.406,20.923h-7.871c-.159-.007-.322-.019-.5-.039A8.615,8.615,0,0,1-185.6,17.7a8.614,8.614,0,0,1-1.86-6.371A21.825,21.825,0,0,1-183.534-1.07a33.535,33.535,0,0,1,9.857-9.269,50.905,50.905,0,0,1,12.923-5.808,47.444,47.444,0,0,1,13.122-2.011h5.332a48.625,48.625,0,0,1,13.331,2.011,51.17,51.17,0,0,1,13.03,5.808,33.485,33.485,0,0,1,9.9,9.269,21.791,21.791,0,0,1,3.933,12.395v.356c.009.11.016.225.021.338a8.5,8.5,0,0,1-2.255,6.15,8.5,8.5,0,0,1-5.943,2.754h-7.885a26.438,26.438,0,0,0-2.092-10.361,26.531,26.531,0,0,0-5.7-8.461A26.551,26.551,0,0,0-134.421-3.6,26.456,26.456,0,0,0-144.782-5.7,26.461,26.461,0,0,0-155.144-3.6,26.551,26.551,0,0,0-163.6,2.1a26.548,26.548,0,0,0-5.7,8.461A26.474,26.474,0,0,0-171.4,20.923Z",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M-144.785-18.165a20.141,20.141,0,0,0,15.287-6.4,45.252,45.252,0,0,0,9.6-29.16,24.9,24.9,0,0,0-25.363-24.418,24.9,24.9,0,0,0-24.418,24.418,46.561,46.561,0,0,0,9.6,29.481A21.191,21.191,0,0,0-144.785-18.165Z",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11259",
    "data-name": "Path 11259",
    d: "M-166.619,21.029a21.7,21.7,0,0,0,21.726,21.726,21.7,21.7,0,0,0,21.725-21.726A21.7,21.7,0,0,0-144.893-.7,21.7,21.7,0,0,0-166.619,21.029Zm38.042,0a16.129,16.129,0,0,1-2.394,8.469L-153.362,7.107a16.246,16.246,0,0,1,8.469-2.394A16.359,16.359,0,0,1-128.577,21.029Zm-32.588,0a16.114,16.114,0,0,1,2.394-8.468l22.391,22.39a16.4,16.4,0,0,1-8.513,2.4A16.292,16.292,0,0,1-161.165,21.029Z",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockedUsers);
export default __webpack_public_path__ + "static/media/blockedUsers.a3afb997cc574440fcf5c3e5b31e4187.svg";
export { ForwardRef as ReactComponent };